<template>
  <v-card
    elevation="2"
    outlined
  >
    <v-card-title class="title text--primary text-left">
      {{ $t('help.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('help.subtitle') }}
    </v-card-subtitle>
    <v-card-text class="text--primary text-left">
      <p>
        {{ $t('help.needHelp') }}
      </p>

      <p>
        <i18n path="help.contactInfo">
          <template #phone>
            <a href="tel:+4544999998">4499 9998</a>
          </template>
          <template #email>
            <a href="mailto:support@tpa-solutions.dk">support@tpa-solutions.dk</a>
          </template>
        </i18n>
      </p>

      <p>
        {{ $t('help.officeHours') }}
      </p>

      <v-alert
        outlined
        type="warning"
        border="top"
        max-width="500"
        class="text-left"
      >
        {{ $t('help.noData') }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Help"
};
</script>